export function range(n: number) {
  const a: number[] = []
  for (let i = 0; i < n; ++i) {
    a.push(i)
  }
  return a
}
